enum Colors {
  Primary100 = "#7f9b28",
  Primary120 = "#6f8a1a",
  Primary20 = "#eff8d6",
  White100 = "#ffffff",
  Gray100 = "#2e2c36",
  Gray80 = "#6c6e6a",
  Gray60 = "#b3b9c2",
  Gray40 = "#eceff2",
  Gray20 = "#f7f8f9",
  Dark100 = "#050f08",
}

export default Colors;
